var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSpeedometer = function SvgSpeedometer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#speedometer_svg__a)",
    fill: "#7F939D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 15.625H.5v-1.25c0-5.516 4.484-10 10-10s10 4.484 10 10v1.25Zm-19.167-.833h18.334v-.417c0-5.052-4.115-9.167-9.167-9.167s-9.167 4.115-9.167 9.167v.417Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.207 10.493.59.589-2.825 2.825-.59-.59 2.825-2.824Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15.208h-.833v-.833A6.673 6.673 0 0 0 10.5 7.708a6.673 6.673 0 0 0-6.667 6.667v.833H3v-.833c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5v.833Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.583 15.209h-.833v-.417c0-.688-.562-1.25-1.25-1.25s-1.25.562-1.25 1.25v.417h-.833v-.417a2.083 2.083 0 1 1 4.166 0v.417ZM10.083 4.792h.834v2.5h-.834v-2.5ZM17.189 7.516l.59.589-1.769 1.768-.589-.59 1.768-1.767ZM3.814 7.514 5.58 9.28l-.589.59-1.768-1.768.59-.59Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "speedometer_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgSpeedometer;